import { SendingDomainStatusEnum } from '@reach/shared-types/channels';
import styles from './SendingDomainStatusSummary.module.css';

const STATUS_COPY: Record<SendingDomainStatusEnum, { label: string; description: string }> = {
  [SendingDomainStatusEnum.VERIFIED]: {
    label: 'Email domain verified',
    description: "The tenant's email sending domain passed DNS verification.",
  },
  [SendingDomainStatusEnum.PENDING_VERIFICATION]: {
    label: 'Email domain verifying',
    description: 'DNS records were added recently. Verification can take up to 48 hours.',
  },
  [SendingDomainStatusEnum.NEEDS_ATTENTION]: {
    label: 'Email domain needs attention',
    description:
      "The tenant's email sending domain isn't verified. Its DNS records are missing or incorrect, or setup was never finished.",
  },
};

interface SendingDomainStatusSummaryProps {
  status: SendingDomainStatusEnum | null | undefined;
}

export const SendingDomainStatusSummary = ({ status }: SendingDomainStatusSummaryProps) => {
  if (!status) {
    return null;
  }

  const { label, description } = STATUS_COPY[status];

  return (
    <span className={styles.summary} data-status={status} title={description}>
      <span className={styles.dot} aria-hidden />
      <span>{label}</span>
    </span>
  );
};
